import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from '../common/SvgIcon.vue';

interface Props {
  title: string,
  iconName?: string,
  hasMore?: boolean,
  hideHoverEffect?: boolean,
  disabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    title: null,
    iconName: null,
    hasMore: { type: Boolean },
    hideHoverEffect: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ['click', 'click-icon', 'click-more'],
  setup(__props: any) {





return { __sfc: true,SvgIcon }
}

})